module.exports = __webpack_public_path__ + "static/ralphrouwen-86e5b186d272492f75383ca39555c224.png";